var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.45,
    height: 23.348,
    viewBox: "0 0 23.45 23.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18414",
    "data-name": "Group 18414",
    transform: "translate(0.39 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18317",
    "data-name": "Group 18317",
    transform: "translate(0.11 0.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25532",
    "data-name": "Path 25532",
    d: "M13.067,21.557h7.3a1.788,1.788,0,0,1,1.788,1.788V40.271a1.788,1.788,0,0,1-1.788,1.788H3.444a1.788,1.788,0,0,1-1.788-1.788v-7.3",
    transform: "translate(0.292 -19.711)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25534",
    "data-name": "Path 25534",
    d: "M102.61,20.426l-11.7-11.7-2,2-.725-9.065,9.065.725-2,2,7.35,7.349",
    transform: "translate(-88.187 -1.657)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.26246a1f5c812da7077465fabe845a4d.svg";
export { ForwardRef as ReactComponent };